/**
 * `<RouteFallback>` — the shared Suspense fallback for lazily-loaded route
 * chunks. Replaces the per-feature `Loading()` spinners that each `routes.tsx`
 * hand-rolled identically.
 */

import { Spinner } from "@cometchat-ai/ui-dashboard";

export function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <Spinner aria-label="Loading" />
    </div>
  );
}
